@if (toasterData?.title) {
  <p class="c__title is-body-l is-bold">
    {{toasterData.title}}
  </p>
}

@if (toasterData?.description) {
  <sd-html innerClass="is-overline" [html]="toasterData?.description" />
}
